// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","771":"component---src-pages-page-2-js"}[chunkId] + "-" + {"125":"6b76f4f1998c60255af5","223":"01a8ef9a1081be3484aa","293":"385a3b11b3ca9e0087f2","771":"f3e9f5cdb1da18f01cc6"}[chunkId] + ".js";
};